export const InsightConstants = {
    INTERESTING_INSIGHTS : {
        name : 'Insight',
        bannerColor : '--color_1'
    },
    ENERGY_SAVING_RECO : {
        name : "Recommendation",
        bannerColor : '--color_16'
    }
}